import { Button, CardMedia, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import BackArrow from "../../../components/BackArrow";
import { helpHttp } from "../../../helper/helpHttp";
import { changeLoading } from "../../../redux/slices/category";
import * as Styled from "./Course.styled";
import { BuildingPage } from "../../../components/BuildingPage/BuildingPage";
import Loader from "../../../components/Loader";
import { useCertificate } from "./useCertificate";
import { useUser } from "../../../hooks/useUser";

const fleischmannV2 = {
  37: "Harina",
};

export const Course = ({ isVentas = false }) => {
  const [courseId, setCourseId] = useState(null);
  const [modules, setModules] = useState([]);
  const { get, post } = helpHttp();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const { generateCertificate } = useCertificate();
  const { user } = useUser();

  const getModulosURL = (id) => {
    if (isVentas || fleischmannV2[id]) {
      return "modulos/getModulosByCategoriaGeneral";
    }
    return "modulos/getModulosByCategoria";
  };

  useEffect(() => {
    if (courseId) {
      dispatch(changeLoading(true));

      get(`${getModulosURL(courseId)}/${courseId}`)
        .then((data) => {
          setModules(data.datos);
        })
        .catch(() => toast.error("Ha ocurrido un error"))
        .finally(() => {
          setLoading(false);
          dispatch(changeLoading(false));
        });
    }
  }, [courseId]);

  const downloadCertificate = async () => {
    get(`${getModulosURL(courseId)}/${courseId}`)
      .then((data) => {
        if (data.datos.every(({ aprobado }) => aprobado === "1")) {
          post(`usuarios/clicCertificadoModuloUsuario`, {
            body: { modulo: courseId },
          });

          get(`categorias/getCategoriaById/${courseId}`).then(({ datos }) => {
            generateCertificate({
              name: `${user?.nombres} ${user?.apellidos}`,
              module: datos?.nombre?.toUpperCase(),
            });
          });
        } else {
          toast.error("Aún no tiene todos los módulos aprobados.");
        }
      })
      .catch(() => toast.error("Ha ocurrido un error"));
  };

  useEffect(() => {
    const url = window.location.href;
    const id = url.split("/").at(-1);
    if (url && id) {
      setCourseId(id);
    }
  }, []);

  if (loading) {
    return <></>;
  }

  return (
    <>
      <BackArrow />
      <Typography sx={{ textAlign: "center" }} fontSize={"1.3rem"}>
        Completa cada uno de los módulos para desbloquear el siguiente y obtener
        tu certificado.
      </Typography>
      <Styled.GridData>
        {modules?.length > 0 &&
          modules.map((element) => (
            <Styled.StyledCard estado={element.estado} key={element.id}>
              {element.estado === "habilitado" ? (
                <>
                  <Link to={`${element.id}`}>
                    <CardMedia
                      component="img"
                      image={element.url_pdf}
                      alt={element.nombre}
                      title={element?.descripcion}
                      className="enable"
                    />
                    {element?.descripcion?.trim() && (
                      <div
                        style={{
                          whiteSpace: "pre-line",
                          padding: "15px",
                          maxWidth: "280px",
                        }}
                      >
                        {element?.descripcion
                          ?.split("\n")
                          .map((line, index) => {
                            const [key, value] = line.split(":");
                            return (
                              <div style={{ textAlign: "left" }} key={index}>
                                <b>{key}:</b> {value}
                              </div>
                            );
                          })}
                      </div>
                    )}
                  </Link>
                </>
              ) : (
                <>
                  <CardMedia
                    component="img"
                    image={element.url_pdf}
                    alt={element.nombre}
                  />
                  {element?.descripcion && (
                    <div
                      style={{
                        whiteSpace: "pre-line",
                        padding: "15px",
                        maxWidth: "280px",
                      }}
                    >
                      {element?.descripcion.split("\n").map((line, index) => {
                        const [key, value] = line.split(":");
                        return (
                          <div style={{ textAlign: "left" }} key={index}>
                            <b>{key}:</b> {value}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </>
              )}
            </Styled.StyledCard>
          ))}
      </Styled.GridData>
      <Button
        color="secondary"
        sx={{ width: "275px", margin: "20px auto" }}
        variant="contained"
        onClick={downloadCertificate}
      >
        Descargar certificado
      </Button>
    </>
  );
};
